import React, { useEffect, useMemo, useContext } from "react";
import { MessageSendType } from "@/types/chat/enum";
import "./index.less";
import { MessageStatus, SessionType, TextChatMessageExt } from "@/types/chat";
import ChatState, { UserState } from "@/types/chat/State";
import { useTranslation } from "react-i18next";
import { UserCardData } from "@/types/UserCard";
import Context from "@/components/chat/context";
import { EBookSubDeptInfo } from "@/models/ebook";
import ReplyMessage from "../ReplyMessage";
import { message as toast } from "antd";
import { handleOpenMentionUserInfo } from "@/utils/chat/index";
import { connect } from "dva";
import {
  getNumber,
  compressString,
  messageToObj,
  joinMeeting
} from "@/baseComponents/Meeting/utils";
import CopyClipboard from "copy-to-clipboard";
import { AVSDK } from "@/baseComponents/Meeting/common";
import JrtcIcon from "@/assets/img/meeting/icon-jrtc-meeting.png";

import "./MeetingInviteCard.less";
interface TextProps {
  sText?: string;
  sMid?: number;
  message: TextChatMessageExt; // 发送消息内容
  sessionType: SessionType;
  sendType: MessageSendType;
  beginSend: boolean;
  messageExtend: any;
  isMergeForward?: boolean;
  curSearchMessgae?: any;
  searchKey?: string;
  onReady: (params: { beginSend: boolean; messageExtend: any }) => {};
}

interface DvaDispatchProps {
  unLock: Function;
}

type ITextProps = Readonly<
  TextProps & UserState & DvaDispatchProps & ChatState & EBookSubDeptInfo & UserCardData
>;
function MeetingInviteCard(props: ITextProps) {
  const { sendType, message, onReady, selectedSession } = props;
  const { groupRosterIdentity, currentEmployee } = useContext(Context);

  const { t } = useTranslation("chat");
  const { meetingCard } = message as any;

  useEffect(() => {
    if (
      (sendType === MessageSendType.OWNER || sendType === MessageSendType.SELF) &&
      message.status === MessageStatus.INIT
    ) {
      onReady({ beginSend: true, messageExtend: {} });
    }
  }, [sendType, message, onReady]);

  const copy = () => {
    const copyText = `会议类型：智能会议\n${message.content}`;
    if (message.content && CopyClipboard(copyText)) {
      toast.success("复制成功");
    } else {
      toast.error("复制失败");
    }
  };

  if (!meetingCard.meetingId) {
    return null;
  }
  const { meetingHost, meetingTitle, meetingPsw, meetingId } = meetingCard;
  return (
    <div className="content">
      <div
        className="message  meeting-invite-card"
        onClick={(e) =>
          handleOpenMentionUserInfo(e, t, {
            currentEmployee,
            selectedSession,
            groupRosterIdentity
          })
        }
      >
        <ReplyMessage message={message} sendType={sendType} />

        <div className={`top-box ${selectedSession.isSecret ? "top-box_isSecret" : ""}`}>
          <div className="header">智能会议</div>
          <div className="msg-content">
            <div className="info">
              <div className="title">{meetingTitle}</div>
              <div className="desc">创建人: {meetingHost}</div>
              <div className="desc">
                会议号:{meetingId} {meetingPsw ? `密码:${meetingPsw}` : ""}
              </div>
            </div>
            <img className="icon" src={JrtcIcon} alt="" />
          </div>
          <div className="card-footer">
            <div className="card-footer-btn" onClick={copy} style={{ marginRight: "40px" }}>
              复制
            </div>
            <div
              className="card-footer-btn"
              onClick={() => {
                joinMeeting(AVSDK.JBRTC, {
                  meetingNumber: meetingId,
                  meetingPassword: meetingPsw
                }).catch((err) => {
                  toast.error(err?.message || err || "加入会议失败");
                });
              }}
            >
              立即入会
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
function mapDispatchToProps() {
  return {};
}
function mapStateToProps({ chat }: { chat: ChatState }) {
  const { currentEmployee, selectedSession, connectState } = chat;
  return {
    userInfo: currentEmployee,
    currentEmployee,
    selectedSession,
    connectState
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MeetingInviteCard);
